/* eslint-disable import/no-default-export */
import React from 'react';

import Badge from '../Badge';

const TextFieldBadge = ({ field, item }) => {
  if (!item || !item.value || !item.value.text) {
    return null;
  }

  return (
    <Badge>
      <span>{`${field.name}: ${item.value.text}`}</span>
    </Badge>
  );
};

export default TextFieldBadge;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/badges/TextFieldBadge.js